import React, { useState } from "react";
import { Box, HStack, Icon, IconButton, Text, VStack } from "@chakra-ui/react";
import { CaretDown, CaretUp } from "@phosphor-icons/react";
import SilabusUploadProccessItem from "./SilabusUploadProccess";
import useSilabusUploadProccesses from "../../globalState/useSilabusUploadProcesses";

export default function SilabusUploadProccesses() {
  const [progressMinimize, setProgressMinimize] = useState(false);
  const { setSilabusUploadProccesses, silabusUploadProccesses } =
    useSilabusUploadProccesses();
  const uploadProcessHeightPerItem = 52;

  // console.log(silabusUploadProccesses);

  return silabusUploadProccesses && silabusUploadProccesses.length > 0 ? (
    <VStack
      align={"stretch"}
      boxShadow={"0 0 5px 2px var(--divider)"}
      p={4}
      pb={2}
      borderRadius={8}
      position={"fixed"}
      bottom={4}
      right={4}
      width="100%"
      maxW={"300px"}
      transition={"200ms"}
      bg={"whiteAlpha.800"}
      backdropFilter={"blur(5px)"}
      overflow={"clip"}
      zIndex={99}
      gap={0}
      h={
        progressMinimize
          ? "64px"
          : `calc(96px + ${
              uploadProcessHeightPerItem * silabusUploadProccesses?.length
            }px)`
      }
    >
      <HStack justify={"space-between"}>
        <Text fontWeight={500}>Sedang Mengunggah...</Text>

        <IconButton
          aria-label="minmize"
          icon={<Icon as={progressMinimize ? CaretUp : CaretDown} />}
          size={"sm"}
          className="btn clicky"
          variant={"ghost"}
          onClick={() => [setProgressMinimize(!progressMinimize)]}
        />
      </HStack>

      <Box h={"1px"} w={"100%"} bg={"var(--divider2)"} my={3} />

      <VStack align={"stretch"} gap={0}>
        {silabusUploadProccesses?.map((silabusUploadProccess, i) => (
          <SilabusUploadProccessItem
            key={i}
            silabusUploadProccess={silabusUploadProccess}
            setSilabusUploadProccesses={setSilabusUploadProccesses}
          />
        ))}
      </VStack>
    </VStack>
  ) : null;
}
